import React from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { IAudition } from '../../types/global/helper';
import { CustomChipGroup } from '../Chip/CustomChipGroup';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';

// Type definition for props
interface IAuditionCell extends Pick<IAudition, 'tags' | 'title' | 'audition_type' | 'id'> {
    onAuditionCellClicked?: (id: string) => void;
}

// Reusable Cell Component
const AuditionCell = ({ title, tags, audition_type, id, onAuditionCellClicked }: IAuditionCell) => {
    const { themeStyle } = useThemeContext();
    return (
        <Paper
            sx={{ padding: 2, margin: 1, backgroundColor: theme[themeStyle].secondaryBg, cursor: 'pointer' }}
            onClick={() => onAuditionCellClicked && onAuditionCellClicked(id)}>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    color: theme[themeStyle].tag_white,
                    fontSize: 12,
                    fontStyle: 'italic',
                }}>
                {audition_type}
            </Typography>
            <Typography sx={{ fontFamily: FONT_ENUM.REGULAR_HEADER, color: theme[themeStyle].tag_white, fontSize: 18 }}>
                {title}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginTop: 1 }}>
                <CustomChipGroup tags={tags} withNiceColor clickable={false} />
            </Box>
        </Paper>
    );
};

// Main Component
export const AuditionList = ({ auditions }: { auditions: IAuditionCell[] }) => {
    return (
        <Stack>
            {auditions.map(audition => (
                <Stack key={audition.id}>
                    <AuditionCell {...audition} />
                </Stack>
            ))}
        </Stack>
    );
};
